import type { SxProps, Theme } from '@mui/material';

export const header: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  p: 2,
};

export const headerArtwork: SxProps<Theme> = {
  width: 48,
  height: 48,
  borderRadius: 1,
  objectFit: 'cover',
  flexShrink: 0,
};

export const content: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  p: 2,
  bgcolor: 'background.paper',
};

export const clipRow: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  p: 1.5,
  borderRadius: 1,
  bgcolor: 'background.default',
};

export const timeText: SxProps<Theme> = {
  fontVariantNumeric: 'tabular-nums',
  whiteSpace: 'nowrap',
};

export const footer: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  p: 2,
};
